import { PurchaseItem } from './../../models/plan/purchaseItem.model';
import { Subscription } from 'rxjs/Rx';
import { Resultlist } from '../../models/plan/orderItems';
import { PlanService } from './../../services/plan.service';
import { PlanMainService } from './../service/plan-main.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  OnDestroy,
  Input
} from '@angular/core';
import { Kyoten } from '../../models/plan/kyoten.model';
import { Kyotens, Kyostat } from './../../models/plan/kyotens';
import { Staffs, Stuffstat } from './../../models/plan/staffs';
import { CustomerKubun } from './../../models/plan/customerKubun';
import { Subject } from 'rxjs/Subject';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-purchase-search',
  templateUrl: './purchase-search.component.html',
  styleUrls: ['./purchase-search.component.css']
})
export class PurchaseSearchComponent implements OnInit, OnDestroy {
  showQuot2 = false;
  @Output('close') close: any = new EventEmitter<any>();
  @Output() chumonvalue: any = new EventEmitter();
  @Input() showCustomerSearch: boolean = false;

  public listOrder: Resultlist[] = [];
  public selectedRow: number;
  public orderItemsdata: Resultlist;

  public display = false;
  public makerData: any[] = [];
  public filtermakerData: any[] = [];
  public makerIndexForClear: any;
  public displayModel = false;
  public makerdisplay = false;
  /////////////////////
  public modelData: any[] = [];
  public filtermodelData: any[] = [];
  public modeldisplay = false;
  public modelIndexForClear: any;

  ///////////////////////////
  public gradesdata: any;
  public gradesDispaly = false;
  public gradesIndexForClear: any;

  public chumonNo: string = null;
  public hanbaiDestinationFn: string = null;
  public makerCd: string = null;
  public modelCd: string = null;
  public zaikoShatenCd: string = null;
  public zaikoKanriCd: string = null;
  public hanbaiKyotenCd: string = null;
  public hanbaiKyotenNm: string = null;
  public hanbaiTantouCd: string = null;
  public hanbaiTantouNm: string = null;
  public hanbaiDestinationKanji: string = null;
  public kkkbn: number = null;
  public chumonYmd: string = null;
  // public newcarfig: number = 1;
  public useCar = 0;
  public numSearch: number;

  public purchaseItem: PurchaseItem = {};

  public kyotendisplay = false;
  public kyotens: Kyostat[] = [];

  public tantoudisplay = false;
  public tantous: Stuffstat[] = [];

  public shatendisplay = false;
  public shatens: any[] = [];

  public customerKbn: CustomerKubun[] = [];

  public ngUnsubscribe = new Subject();

  public carvalue: any = [
    {
      makerNm: null,
      makerCd: null,
      modelCd: null,
      modelNm: null,
      gradeNm: null,
      gradeCd: null
    }
  ];
  public dataTotalSize: number;
  public searchChunk: any[];
  public page = 0;

  public dataSharyou = [
    {kbn: null, text: ''},
    {kbn: 1, text: '新車'},
    {kbn: 2, text: '中古'},
    {kbn: 3, text: '未使用車'}];
  public sharyouKbn: number = 1;

  constructor(
    private _planmainService: PlanMainService,
    private planService: PlanService,
    private _data: DataService,
    private router: Router
  ) { }
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      if (this.orderItemsdata != null) {
        this.onenterData(this.orderItemsdata, this.selectedRow);
      }
    }
  }

  ngOnInit() {
    this.getPlanUsecar();
    this.getQoutsearch();
    this.getCustomerKbn();
    // if (this.useCar === 1) {
    //   this.newcarfig = 1;
    // }
    if (this._data && this._data.staffData) {
      this.zaikoShatenCd = this._data.staffData.shatenCd;
    }
    //  else {
    //   this.newcarfig = ;
    // }
  }

  getPlanUsecar() {
    this.useCar = 0;
    this.planService.passingPlanUsedcar
      .subscribe(e => {
        if (e !== undefined && e !== null && e !== '') {
          this.useCar = +e;
          if (this.useCar === 0) {
            if (this.router.url !== '/home') {
              this.dataSharyou = this.dataSharyou.filter(item => item.kbn === 1);
            }
            this.sharyouKbn = 1;
          } else if (this.useCar === 1) {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn === 2);
            this.sharyouKbn = 2;
          } else {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn !== 1);
            this.sharyouKbn = null;
          }
        }
      })
      .unsubscribe();
  }

  // onChangeNewcarflag(event) {
  //   // this.newcarfig = event;
  //   console.log(this.newcarfig);
  // }

  onClose() {
    this.close.emit();
  }

  closeFilter() {
    this.showQuot2 = false;
  }

  onsearch() {
    this.orderItemsdata = null;
    this.selectedRow = null;
    this.dataTotalSize = 0;
    this.listOrder = null;
    // console.log('Search');
    // console.log(this.useCar);

    // console.log(this.newcarfig);

    // if (this.useCar == '1' && this.newcarfig == null) {
    //   this.newcarfig = 1;
    // }
    // else if () {

    // }

    // if (this.useCar == '1' && this.newcarfig == null) {
    //   this.newcarfig = Number(this.useCar);
    // }
    // else if (this.useCar == '') {
    //   this.newcarfig = 0;
    // }

    const purchaseItem = {
      // newcarFlg: this.newcarfig,
      sharyouKbn: this.sharyouKbn,
      chumonNo: this.chumonNo,
      hanbaiDestinationFn: this.hanbaiDestinationFn,
      makerCd: this.carvalue.makerCd,
      modelCd: this.carvalue.modelCd,
      zaikoShatenCd: this.zaikoShatenCd,
      zaikoKanriCd: this.zaikoKanriCd,
      hanbaiKyotenCd: this.hanbaiKyotenCd,
      hanbaiTantouCd: this.hanbaiTantouCd, // this.hanbaiDestinationFn,
      hanbaiDestinationKanji: this.hanbaiDestinationKanji,
      kkkbn: this.kkkbn,
      chumonYmd: this.chumonYmd
    };

    // console.log(Object.(this.purchaseItem).filter(e => e != '' && e != null));

    this._planmainService
      .getOrderItems(purchaseItem)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(response => {
        if (response && response.result.length > 0) {
          const newlistData = [...response.result];
          const arr = [];
          const size = 10;
          while (newlistData.length > 0) {
            arr.push(newlistData.splice(0, size));
          }
          this.page = 0;
          this.searchChunk = arr;
          this.listOrder = this.searchChunk[this.page];
          this.dataTotalSize = response.totalSize;
        }
      });
  }

  onselectDate(event: any) {
    this.chumonYmd = this._planmainService.setStringdate(
      'YYYYMMDD',
      event.value
    );
  }

  onDatevalue(event) {
    if (event && event.value) {
      this.chumonYmd = this._planmainService.setStringdate(
        'YYYYMMDD',
        event.value
      );
    } else {
      this.chumonYmd = null;
    }
  }

  setClickedRow(index: any, data: any) {
    // console.log(index);

    if (this.selectedRow !== index) {
      this.selectedRow = index;
      this.orderItemsdata = data;
    } else {
      this.selectedRow = null;
      this.orderItemsdata = null;
    }
    // this.selectedRow = index;
    // this.orderItemsdata = data;
  }

  onConfirm() {
    if (this.orderItemsdata != null) {
      this.chumonvalue.emit(this.orderItemsdata.chumonNo);
      this._data.saveData('ordersNo', this.orderItemsdata);
      // this._planmainService.setpurchaseSearch(this.orderItemsdata);
      this.close.emit();
    }
  }

  onDbclickTable(data: Resultlist) {
    this._data.removeOrderNoMitsumoriNo();
    if (data != null) {
      this.chumonvalue.emit(data.chumonNo);
      this._data.saveData('ordersNo', data);
      // this._planmainService.setpurchaseSearch(data);
      this.close.emit();
    }
  }

  onenterData(data: Resultlist, index: any) {
    if (data != null) {
      this.chumonvalue.emit(data.chumonNo);
      // this._planmainService.setpurchaseSearch(data);
      this.close.emit();
    }
  }

  onShowdialog() {
    this.display = true;
    this.makerdisplay = true;
    if (this.makerData.length === 0) {
      this.planService
        .getMakersDataCar()
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          if (res) {
            this.makerData.push({
              makerCd: '00000',
              makerNm: '未選択',
              stat: false
            });
            res.forEach((val, i) => {
              this.makerData.push({
                makerCd: val.makerCd,
                makerNm: val.makerNm,
                stat: false
              });
            });
          } else {
            this.makerData = res;
          }
        });
    }
  }

  showDialogModel() {
    this.display = true;
    this.modeldisplay = true;
    this.makerdisplay = false;
    if (this.modelData.length === 0) {
      this.planService
        .getModelsDataCar(this.carvalue.makerCd)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          if (res) {
            this.modelData.push({
              modelNm: '未選択',
              modelCd: '00000',
              stat: false
            });
            res.forEach((val, i) => {
              this.modelData.push({
                modelNm: val.modelNm,
                modelCd: val.modelCd,
                stat: false
              });
            });
          } else {
            this.modelData = res;
          }
        });
    }
  }

  filterMakerList(index: any) {
    this.filtermakerData = this.filtermakerData.filter(e => e.stat !== false);
      this.planService
        .getMakersDataCar(index)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          if (res) {
            this.makerData = [];
            this.makerData.push({
              makerCd: '00000',
              makerNm: '未選択',
              stat: false
            });

            res.forEach((val, i) => {
              if (
                this.filtermakerData.length !== 0 &&
                this.filtermakerData[0].makerCd === val.makerCd
              ) {
                this.makerData.push({
                  makerCd: val.makerCd,
                  makerNm: val.makerNm,
                  stat: true
                });
              } else {
                this.makerData.push({
                  makerCd: val.makerCd,
                  makerNm: val.makerNm,
                  stat: false
                });
              }
            });
          } else {
            this.makerData = res;
          }
        });
  }

  filterModelList(index: any) {
    this.filtermodelData = this.filtermodelData.filter(e => e.stat !== false);
      this.planService
        .getModelsDataCar(this.carvalue.makerCd, index)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          if (res) {
            this.modelData = [];
            this.modelData.push({
              modelNm: '未選択',
              modelCd: '00000',
              stat: false
            });
            res.forEach((val, i) => {
              if (
                this.filtermodelData.length !== 0 &&
                this.filtermodelData[0].modelCd === val.modelCd
              ) {
                this.modelData.push({
                  modelNm: val.modelNm,
                  modelCd: val.modelCd,
                  stat: true
                });
              } else {
                this.modelData.push({
                  modelNm: val.modelNm,
                  modelCd: val.modelCd,
                  stat: false
                });
              }
            });
          } else {
            this.modelData = res;
          }
        });
  }

  makerSelected(maker: any, event: any) {
    if (maker.makerCd == '00000') {
      for (let i = 0; i < this.makerData.length; i++) {
        this.makerData[i].stat = false;
      }
      this.makerData.forEach((val, i) => {
        if (maker.makerCd !== val.makerCd) {
          this.makerData[i].stat = false;
        }
      });

      setTimeout(() => {
        this.carvalue.makerNm = '';
        this.carvalue.makerCd = '';
        this.carvalue.modelNm = '';
        this.carvalue.modelCd = '';
        this.oncloseDialog(event);
        this.makerData = [];
        this.modelData = [];
        this.display = false;
      }, 500);
    } else {
      this.carvalue.makerNm = maker.makerNm;
      this.carvalue.makerCd = maker.makerCd;
      setTimeout(() => {
        this.carvalue.modelCd = null;
        this.carvalue.modelNm = null;
        this.carvalue.gradeNm = null;
        this.modelData = [];
        this.oncloseDialog(event);
        this.display = false;
      }, 500);
    }

    this.filtermakerData = this.makerData;
  }

  checkedMakerSelected(event: any, i: any) {
    this.makerIndexForClear = i;
    if (this.makerData[i].stat == event) {
      this.makerData[i].stat = false;
      this.carvalue.makerNm = null;
      this.carvalue.makerCd = null;
    } else {
      this.makerData.forEach((e, index) => {
        if (i === index) {
          this.makerData[index].stat = true;
        } else {
          this.makerData[index].stat = false;
        }
      });
    }
  }

  modelSelected(model: any, event: any) {
    if (model.modelCd == '00000') {
      // for (let i = 0; i < this.modelData.length; i++) {
      //   this.modelData[i].stat = false;
      // }
      // console.log(this.modelData);
      this.modelData.forEach((val, i) => {
        if (model.modelCd !== val.modelCd) {
          this.modelData[i].stat = false;
        }
      });
      setTimeout(() => {
        this.display = false;
        this.modeldisplay = false;
        this.carvalue.modelNm = '';
        this.carvalue.modelCd = '';
        this.oncloseDialog(event);
        this.modelData = [];
        this.display = false;
        // this.checkedModelSelected(events, indexs);
      }, 500);
    } else {
      this.carvalue.modelCd = model.modelCd;
      this.carvalue.modelNm = model.modelNm;
      setTimeout(() => {
        this.carvalue.gradeNm = null;
        this.oncloseDialog(event);
        this.display = false;
        // this.checkedModelSelected(events, indexs);
      }, 500);
    }
    // console.log(this.carvalue.modelNm);
    this.filtermodelData = this.modelData;
  }

  checkedModelSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    if (this.modelData[i].stat == event) {
      this.modelData[i].stat = false;
      this.carvalue.modelNm = '';
      this.carvalue.modelCd = '';
    } else {
      this.modelData.forEach((e, index) => {
        if (i === index) {
          this.modelData[index].stat = true;
        } else {
          this.modelData[index].stat = false;
        }
      });
    }
  }

  oncloseDialog(event: any) {
    this.display = false;
    this.makerdisplay = false;
    this.modeldisplay = false;
    this.gradesDispaly = false;
    this.kyotendisplay = false;
    this.tantoudisplay = false;
  }

  onShowQuot2(e: number) {
    this.showQuot2 = true;
    this.numSearch = e;
  }

  getQoutsearch() {
    this._planmainService.listdatacustomers
      .takeUntil(this.ngUnsubscribe)
      .subscribe((val) => {
        console.log(val);
        if (this.numSearch === 1) {
          this.hanbaiDestinationKanji =
            val.kojinNmKjSei + ' ' + val.kojinNmKjMei;
        } else if (this.numSearch === 2) {
          this.hanbaiDestinationFn = val.kojinNmKnSei + ' ' + val.kojinNmKnMei;
        }
      }
      );
  }

  getKyoten() {
    // this.display = true;
    this.kyotendisplay = true;
    if (this.hanbaiKyotenCd == null) {
      this.kyotens = [];
      this._planmainService.getkyotens().subscribe((res: Kyotens[]) => {
        this.kyotens.push({
          kyotenCd: '000',
          kyotenNm: '未選択',
          kyostat: false
        });
        res.forEach((val, i) => {
          this.kyotens.push({
            kyotenCd: val.kyotenCd,
            kyotenNm: val.kyotenNm,
            kyostat: false
          });
        });
      });
    }
  }

  kyotenSelected(kyoten: any, event: any) {
    if (kyoten.kyotenCd === '000') {
      setTimeout(() => {
        this.kyotens.forEach((val, i) => {
          if (kyoten.kyotenCd !== val.kyotenCd) {
            this.kyotens[i].kyostat = false;
          }
        });

        this.hanbaiKyotenNm = '';
        this.hanbaiTantouNm = '';
        this.hanbaiKyotenCd = null;
        this.hanbaiTantouCd = null;
        this.oncloseDialog(event);
        this.display = false;
      }, 500);
    } else {
      // setTimeout(() => {
      //   this.hanbaiKyotenCd = kyoten.kyotenCd;
      //   this.hanbaiKyotenNm = kyoten.kyotenNm;
      //   this.hanbaiTantouNm = '';
      //   this.hanbaiTantouCd = null;
      //   this.oncloseDialog(event);
      //   this.display = false;
      // }, 500);
      const index = this.kyotens.findIndex(e => e.kyotenCd === kyoten.kyotenCd);
      setTimeout(() => {
        if (index > -1 && this.kyotens[index].kyostat) {
          this.hanbaiKyotenCd = kyoten.kyotenCd;
          this.hanbaiTantouCd = null;
          this.hanbaiKyotenNm = kyoten.kyotenNm;
          this.hanbaiTantouNm = '';

          this.oncloseDialog(event);
          this.display = false;
        } else if (index > -1 && !this.kyotens[index].kyostat) {
          this.hanbaiKyotenNm = '';
          this.hanbaiTantouNm = '';
          this.hanbaiKyotenCd = null;
          this.hanbaiTantouCd = null;
          this.oncloseDialog(event);
          this.display = false;
        }
      }, 500);
    }
  }

  checkedKyotenSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.kyotens[i].kyostat === event) {
      this.kyotens[i].kyostat = false;
      // this.carvalue.modelNm = null;
      this.hanbaiKyotenCd = null;
    } else {
      for (let i = 0; i < this.kyotens.length; i++) {
        this.kyotens[i].kyostat = false;
      }
      this.kyotens[i].kyostat = true;
    }
  }

  displayTantou() {
    this.tantoudisplay = true;
    if (this.tantous.length === 0) {
      this.getTantou();
    }
  }

  getTantou() {
    if (this.hanbaiTantouCd === null) {
      this.tantous = [];
      this._planmainService.getStaffname().subscribe(res => {
        if (res) {
          this.tantous.push({
            staffCd: '000',
            staffNm: '未選択',
            staffstat: false
          });
          res.forEach((val, i) => {
            this.tantous.push({
              staffCd: val.staffCd,
              staffNm: val.staffNm,
              staffstat: false
            });
          });
        }
      });
    }
  }

  tantouSelected(tantou: any, event: any) {
    if (tantou.staffCd === '000') {
      setTimeout(() => {
        // this.tantous.forEach((val, i) => {
        //   if (tantou.staffCd !== val.staffCd) {
        //     this.kyotens[i].kyostat = false;
        //   }
        // });
        this.hanbaiTantouNm = '';
        this.hanbaiTantouCd = null;
        this.oncloseDialog(event);
        this.display = false;
      }, 500);
    } else {
      // setTimeout(() => {
      //   this.hanbaiTantouCd = tantou.staffCd;
      //   this.hanbaiTantouNm = tantou.staffNm;
      //   // this.kyotens = kyoten;
      //   console.log(tantou);
      //   this.oncloseDialog(event);
      //   this.display = false;
      // }, 500);
      const index = this.tantous.findIndex(e => e.staffCd === tantou.staffCd);
      setTimeout(() => {
        if (index > -1 && this.tantous[index].staffstat) {
          this.hanbaiTantouCd = tantou.staffCd;
          this.hanbaiTantouNm = tantou.staffNm;
          this.oncloseDialog(event);
          this.display = false;
        } else if (index > -1 && !this.tantous[index].staffstat) {
          this.hanbaiTantouCd = null;
          this.hanbaiTantouNm = '';
          this.oncloseDialog(event);
          this.display = false;
        }
      }, 500);
    }
  }

  checkedTantouSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.tantous[i].staffstat === event) {
      this.tantous[i].staffstat = false;
      // this.carvalue.modelNm = null;
      this.hanbaiKyotenCd = null;
    } else {
      for (let i = 0; i < this.tantous.length; i++) {
        this.tantous[i].staffstat = false;
      }
      this.tantous[i].staffstat = true;
    }
  }

  getZaikoShaten() {
    this.shatendisplay = true;
    this.shatens = [];
    this._planmainService.getzaikoShaten().subscribe(res => {
      this.shatens = res;
      this.zaikoShatenCd = this.shatens[0].shatenCd;
      // res.forEach((val, i) => {
      //   this.tantous.push({ staffCd: val.staffCd, staffNm: val.staffNm, staffstat: false });
      // });
    });
  }

  getCustomerKbn() {
    this._planmainService
      .getCustomerKubun()
      .subscribe((res: CustomerKubun[]) => {
        if (res) {
          this.customerKbn = res;
        }
        // console.log(res);
      });
  }

  onZeroFill1(event) {
    this.chumonNo = event;
  }

  onZeroFill2(event) {
    this.zaikoKanriCd = event;
  }

  checkLanguage() {
    console.log(
      this._planmainService.checkJapan(this.chumonNo),
      'This is check Language'
    );
    if (this._planmainService.checkJapan(this.chumonNo)) {
      this.chumonNo = '';
      console.log('This is Japan', this.chumonNo);
    } else {
      console.log('This is not Japann', this.chumonNo);
    }
  }

  checkLanguage2() {
    console.log(
      this._planmainService.checkJapan(this.zaikoKanriCd),
      'This is check Language'
    );
    if (this._planmainService.checkJapan(this.zaikoKanriCd)) {
      this.zaikoKanriCd = '';
      console.log('This is Japan', this.zaikoKanriCd);
    } else {
      console.log('This is not Japann', this.zaikoKanriCd);
    }
  }

  onPagination(page: number) {
    this.selectedRow = null;
    this.orderItemsdata = null;
    this.page = page - 1;
    this.listOrder = this.searchChunk[this.page];
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/purchase-search/purchase-search.component.ts